import Group from '@eduzz/ui-layout/Sidebar/Group';
import Item from '@eduzz/ui-layout/Sidebar/Item';
import { BetaModule } from 'components/BetaModule';
import { serializeMenuItemLabel } from 'helpers/menu';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { VERTICAL_URL } from 'settings';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Permission } from './Permission';

import type { Route } from './routes';

type SubMenuRouteProps = {
  route: Route;
};

export const SubMenuRoute = React.memo<SubMenuRouteProps>(({ route }) => {
  const [betaModules] = useObservable(() => eduzzAccountsService.getBetaModules(), []);

  return (
    <Group id={route.label ? `menu-group-${serializeMenuItemLabel(route.label)}` : ''} label={route.label}>
      {route.nodes.map((node) => (
        <Permission key={node.to} route={node}>
          <BetaModule module={node.betaModule}>
            {node.label == 'Ações Pendentes' && betaModules?.includes('refund') ? (
              ''
            ) : node.to.startsWith('http') ? (
              <Item
                id={`menu-item-${serializeMenuItemLabel(route.label)}-${serializeMenuItemLabel(node.label)}`}
                as='a'
                href={node.to}
                target={node.to.includes(VERTICAL_URL) ? '_self' : '_blank'}
                rel='noopener noreferrer'
              >
                {node.label}
              </Item>
            ) : (
              <Item id={`menu-item-${serializeMenuItemLabel(route.label)}-${serializeMenuItemLabel(node.label)}`} as={NavLink} to={node.to}>
                {node.label}
              </Item>
            )}
          </BetaModule>
        </Permission>
      ))}
    </Group>
  );
});
